var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3986 12.5409C12.6915 12.248 13.1664 12.248 13.4593 12.5409L27.6014 26.683C27.8943 26.9759 27.8943 27.4508 27.6014 27.7437C27.3085 28.0366 26.8337 28.0366 26.5408 27.7437L12.3986 13.6015C12.1057 13.3087 12.1057 12.8338 12.3986 12.5409Z",
    fill: "#626262"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6013 12.5409C27.8942 12.8338 27.8942 13.3086 27.6013 13.6015L13.4591 27.7437C13.1662 28.0366 12.6914 28.0366 12.3985 27.7437C12.1056 27.4508 12.1056 26.9759 12.3985 26.683L26.5406 12.5409C26.8335 12.248 27.3084 12.248 27.6013 12.5409Z",
    fill: "#626262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.1756775d8b35df165c29dedf46e67337.svg";
export { ForwardRef as ReactComponent };